
  <div id="#container" *ngIf="chartId != 'unionchart'" style="width:190px;height: 252px;" id="{{chartId}}" >{{chartId}}</div>

  <div id="#container" *ngIf="chartId == 'unionchart'" style="width:400px;height: 252px;" id="{{chartId}}" >{{chartId}}</div>